import {
  NEW_CARS_LISTING_FUEL_TYPE_DIESEL,
  NEW_CARS_LISTING_FUEL_TYPE_DIESEL_ELECTRIC,
  NEW_CARS_LISTING_FUEL_TYPE_ELECTRIC,
  NEW_CARS_LISTING_FUEL_TYPE_PETROL,
  NEW_CARS_LISTING_FUEL_TYPE_PETROL_ELECTRIC,
  NEW_CARS_LISTING_SORT_TYPE_NAME,
  NEW_CARS_LISTING_SORT_TYPE_PRICE,
  NEW_CARS_LISTING_SORT_TYPE_RATING,
  NEW_CARS_LISTING_SORT_TYPE_RELEASE_DATE,
} from './constants';
import type {
  ConvertToCamelCaseResponseMeta,
  NewCarCategoryType,
  NewCarFuelType,
  NewCarPastCarSortType,
  NewCarSortType,
} from './types';

export const isCategoryType = (value: unknown): value is NewCarCategoryType => (
  typeof value === 'string' && ['ad', 'pi', 'a', 'b'].includes(value)
);

export const isNewCarFuelType = (value: unknown): value is NewCarFuelType => ( // @suppress longLineCheck
  typeof value === 'string' && [
    NEW_CARS_LISTING_FUEL_TYPE_DIESEL,
    NEW_CARS_LISTING_FUEL_TYPE_DIESEL_ELECTRIC,
    NEW_CARS_LISTING_FUEL_TYPE_ELECTRIC,
    NEW_CARS_LISTING_FUEL_TYPE_PETROL,
    NEW_CARS_LISTING_FUEL_TYPE_PETROL_ELECTRIC,
  ].includes(value)
);

export const isNewCarSortType = (value: unknown): value is NewCarSortType => ( // @suppress longLineCheck
  typeof value === 'string' && [
    NEW_CARS_LISTING_SORT_TYPE_NAME,
    NEW_CARS_LISTING_SORT_TYPE_PRICE,
    NEW_CARS_LISTING_SORT_TYPE_RATING,
    NEW_CARS_LISTING_SORT_TYPE_RELEASE_DATE,
  ].includes(value)
);

export const isNewCarPastCarSortType = (
  value: unknown,
): value is NewCarPastCarSortType => (
  typeof value === 'string' && [
    NEW_CARS_LISTING_SORT_TYPE_NAME,
    NEW_CARS_LISTING_SORT_TYPE_RELEASE_DATE,
  ].includes(value)
);

export const convertToCamelCaseResponseMeta: ConvertToCamelCaseResponseMeta = ({
  current_page: currentPage,
  from,
  last_page: lastPage,
  links,
  path,
  per_page: perPage,
  to,
  total,
}) => ({
  currentPage,
  from,
  lastPage,
  links,
  path,
  perPage,
  to,
  total,
});
